import { Link, useNavigate } from 'react-router-dom';

export default function ArticleSpotlight() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-3xl p-8 md:p-14 border border-foreground-100/60">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="lg:w-3/5">
              <div className="flex items-center gap-3 mb-5">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-900 text-background-50 text-xs font-semibold rounded-full font-label">
                  <i className="ri-star-fill text-accent-500 text-sm w-5 h-5 flex items-center justify-center"></i>
                  Editor&apos;s Pick
                </span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-5">
                The Ultimate Superbuy Spreadsheet Guide
              </h2>
              <div className="relative pl-6 border-l-2 border-accent-400 mb-6">
                <p className="text-foreground-700 leading-relaxed text-sm md:text-base italic">
                  &ldquo;Whether you are brand new to the world of organized product discovery or a seasoned shopper looking to level up your game, this comprehensive guide walks you through everything you need to know about maximizing your Superbuy Spreadsheet experience. From understanding how spreadsheets are structured to advanced tips for finding hidden gems across every category, this guide has you covered.&rdquo;
                </p>
              </div>
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center overflow-hidden">
                  <i className="ri-user-line text-accent-700 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">Superbuy Editorial</p>
                  <p className="text-xs text-foreground-500">Updated July 2026 · 8 min read</p>
                </div>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={() => navigate('/superbuy-spreadsheet-guide')}
                  className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </button>
                <Link
                  to="/"
                  className="flex items-center gap-2 px-5 py-2.5 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Back to Home
                </Link>
              </div>
            </div>

            <div className="lg:w-2/5">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20creative%20workspace%20with%20mood%20board%20wall%20of%20fabric%20swatches%20product%20photos%20and%20handwritten%20notes%20warm%20task%20lamp%20lighting%20creating%20cozy%20focused%20atmosphere%20design%20studio%20aesthetic%20with%20personal%20touches%20scissors%20and%20measuring%20tape%20scattered%20naturally&width=800&height=600&seq=guide-workspace-july2026&orientation=landscape"
                  alt="Superbuy Spreadsheet Guide"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div
            onClick={() => navigate('/best-superbuy-spreadsheet')}
            className="group p-5 rounded-2xl bg-background-100 border border-foreground-100/60 hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
          >
            <span className="text-xs font-semibold text-foreground-400 font-label uppercase tracking-wider">Top Picks</span>
            <h3 className="text-base font-heading font-semibold text-foreground-950 mt-1.5 mb-1.5 group-hover:text-accent-600 transition-colors">
              Best Superbuy Spreadsheet Finds 2026
            </h3>
            <p className="text-xs text-foreground-500">Curated selection of the most popular community-approved products this year.</p>
          </div>
          <div
            onClick={() => navigate('/superbuy-spreadsheet-shoes')}
            className="group p-5 rounded-2xl bg-background-100 border border-foreground-100/60 hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
          >
            <span className="text-xs font-semibold text-foreground-400 font-label uppercase tracking-wider">Deep Dive</span>
            <h3 className="text-base font-heading font-semibold text-foreground-950 mt-1.5 mb-1.5 group-hover:text-accent-600 transition-colors">
              Superbuy Spreadsheet Shoes Guide
            </h3>
            <p className="text-xs text-foreground-500">Everything about finding the best sneakers and footwear through spreadsheets.</p>
          </div>
        </div>
      </div>
    </section>
  );
}